import CookiesJS from 'cookies-js';

export function initEmailTemplates($, apiClient) {
    $('form.email-template-form .action__entity-save').on('click', async function () {
        try {
            const _id = $(this).attr('data-object-id');
            const emailTemplate = {
                title: $('#title').val(),
                templateUniqueName: $('#templateUniqueName').val(),
                emailSubject: $('#emailSubject').val(),
                emailText: $('#emailText').val(),
                emailHtml: $('#emailHtml').val(),
                deleted: !!$('#deleted').prop('checked'),
            };
            if (!_id) {
                const result = await apiClient.create('/email-templates', emailTemplate, CookiesJS.get('auth_token'));
                console.log(result);
                document.location.href=`/email-templates/edit/${result._id}`;
            } else {
                const result = await apiClient.updateOne('/email-templates', _id, emailTemplate, CookiesJS.get('auth_token'));
                console.log(result);
                alert('Сохранено');
                location.reload();
            }
        } catch (e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });
}
